
export const DsfFormPickUp = dsf.defineAsyncComponent("DsfFormPickUp", () =>
  import(/* webpackChunkName: "platform_pc_other" */ "./formPickUp.vue")
);

export const DsfReportFormPickUp = dsf.defineAsyncComponent("DsfReportFormPickUp", () =>
  import(/* webpackChunkName: "platform_pc_other" */ "./reportFormPickUp.vue")
);
